import * as React from "react";

const IconLinkFilter: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                d="M0,12 L0,13 L0.5,13 L2.5,13 L2.5,14 L2.5,15 L3.5,15 L6.5,15 L7.5,15 L7.5,14 L7.5,13 L15.5,13 L16,13 L16,12 L15.5,12 L7.5,12 L7.5,11 L7.5,10 L6.5,10 L3.5,10 L2.5,10 L2.5,11 L2.5,12 L0.5,12 L0,12 Z M6.5,13 L6.5,14 L3.5,14 L3.5,13 L3.5,12 L3.5,11 L6.5,11 L6.5,12 L6.5,13 Z M0,7 L0,8 L0.5,8 L8.5,8 L8.5,9 L8.5,10 L9.5,10 L12.5,10 L13.5,10 L13.5,9 L13.5,8 L15.5,8 L16,8 L16,7 L15.5,7 L13.5,7 L13.5,6 L13.5,5 L12.5,5 L9.5,5 L8.5,5 L8.5,6 L8.5,7 L0.5,7 L0,7 Z M3.5,3 L3.5,4 L3.5,5 L4.5,5 L7.5,5 L8.5,5 L8.5,4 L8.5,3 L15.5,3 L16,3 L16,2 L15.5,2 L8.5,2 L8.5,1 L8.5,0 L7.5,0 L4.5,0 L3.5,0 L3.5,1 L3.5,2 L0.5,2 L0,2 L0,3 L0.5,3 L3.5,3 Z M4.5,3 L4.5,2 L4.5,1 L7.5,1 L7.5,2 L7.5,3 L7.5,4 L4.5,4 L4.5,3 Z M12.5,7 L12.5,8 L12.5,9 L9.5,9 L9.5,8 L9.5,7 L9.5,6 L12.5,6 L12.5,7 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(IconLinkFilter);
